import { Badge } from '@roger/ui-components';
import type { ColumnDef } from '@tanstack/react-table';

import type { GroupRow } from '../../services/api/types.gen';

export const groupColumns: ColumnDef<GroupRow>[] = [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) => (
      <div className='flex items-center gap-2 font-medium'>
        <span>{row.original.name}</span>
        {row.original.archived_at && (
          <Badge variant='secondary' className='whitespace-nowrap'>
            Archived
          </Badge>
        )}
      </div>
    ),
  },
  {
    accessorKey: 'member_count',
    header: 'Members',
  },
  {
    accessorKey: 'managed_by',
    header: 'Managed by',
    enableSorting: false,
  },
  {
    id: 'channel',
    header: 'Channel',
    enableSorting: false,
    cell: ({ row }) =>
      row.original.channel_kind === 'announcement'
        ? 'Announcements'
        : 'Conversation',
  },
];
